import axios from 'axios';


//const cookiesConsent = localStorage.getItem('cookiesConsent');

export var base_url; 
if (process.env.NODE_ENV === 'production') {
    base_url = 'https://compute.corivia.es:443'
} else {
    base_url = 'http://localhost:5000'
    //base_url = 'https://compute.corivia.es:443'
}
axios.defaults.baseURL = base_url;


export * from './email';
export * from './logs';
export * from './auth';
export * from './users';
export * from './admin';

export { axios };
